export const accountIdSelector = state => state.common.accountId;
